<script setup lang="ts">
import IconClose from '@/shared/assets/icons/IconClose.svg'
</script>

<template>
  <button
    data-test="shared_modal__button_close"
    class="rounded-8 border-1 border-black-300 border-solid p-8"
  >
    <IconClose class="fill-black" />
  </button>
</template>
